
import { computed, defineComponent, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { useMainStore } from '@/store/mainStore';
import AppCreateCasePopUp from '@/components/AppCreateCasePopUp.vue';
import AppCasesListPopUp from '@/components/AppCasesListPopUp.vue';
import AppLabelInput from '@/components/UI/AppLabelInput.vue';
import { IFileUpload, ISearchLabelInput, ITagInput } from '@/types/interfaces';
import DriveCreateCase from '@/modules/drive/view-models/DriveCreateCase.vue';

export default defineComponent({
  emits: ['on-label-delete', 'merge-labels', 'on-cancel', 'on-done', 'on-close'],
  props: {
    filesToUpload: { type: Array as () => IFileUpload[], required: true },
    hideOptionsList: { type: Boolean, default: false },
    labels: { type: Array as () => ISearchLabelInput[], default: [] as ISearchLabelInput[] },
  },
  components: {
    DriveCreateCase,
    AppCasesListPopUp,
    AppLabelInput,
  },
  setup(props, context) {
    const croppedBlobToUrl = computed(() => {
      const blobs = [] as any[];
      props.filesToUpload.forEach((el) => {
        if (el.cUrl) {
          blobs.push({ src: el.cUrl, type: 'VIDEO', poster: el.poster });
        } else {
          blobs.push({ src: URL.createObjectURL(el.file), type: 'IMAGE', coordinates: el.coodrinates });
        }
      });
      return blobs;
    });

    // const createCaseModal = ref();
    const isCreateCase = ref(false);
    const casesListModal = ref();

    function createCaseFromPhoto() {
      isCreateCase.value = true;
    }

    function handleAddToCaseModal() {
      casesListModal.value.isShow = true;
    }

    // Photo labels
    const mainStore = useMainStore();
    const optionsPopup = ref();
    const labelsPopup = ref();
    const showAddLabel = ref(false);
    const labelsToMerge = ref([] as ITagInput[]);

    function addLabelsOpen() {
      let labelList: string[] = [];
      props.filesToUpload.forEach((item) => {
        const existing = item.labels?.map((label) => label.text) || [];
        labelList = [...new Set([...existing, ...labelList])];
      });
      labelList.forEach((label) => {
        if (props.filesToUpload.every((file) => file.labels?.find((fileLabel) => fileLabel.text === label))) {
          mainStore.inputPhotoTags.push({ text: label });
        }
      });
      showAddLabel.value = true;
    }

    function addLabelsClose() {
      labelsToMerge.value = mainStore.inputPhotoTags;
      mainStore.inputPhotoTags = [];
      showAddLabel.value = false;
      context.emit('merge-labels', labelsToMerge.value);
    }
    function closeLabels() {
      mainStore.inputPhotoTags = [];
      showAddLabel.value = false;
    }

    function deleteLabel(label) {
      context.emit('on-label-delete', label);
    }
    onClickOutside(labelsPopup, closeLabels);

    return {
      labelsPopup,
      showAddLabel,
      addLabelsOpen,
      addLabelsClose,
      deleteLabel,

      croppedBlobToUrl,
      isCreateCase,
      casesListModal,

      createCaseFromPhoto,
      handleAddToCaseModal,
    };
  },
});
